/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RqthRefusalReasonResource = {
    Other: 'OTHER',
    IncorrectDocument: 'INCORRECT_DOCUMENT',
    DocumentNotReadable: 'DOCUMENT_NOT_READABLE',
    Expired: 'EXPIRED'
} as const;
export type RqthRefusalReasonResource = typeof RqthRefusalReasonResource[keyof typeof RqthRefusalReasonResource];


export function instanceOfRqthRefusalReasonResource(value: any): boolean {
    for (const key in RqthRefusalReasonResource) {
        if (Object.prototype.hasOwnProperty.call(RqthRefusalReasonResource, key)) {
            // @ts-ignore
            if (RqthRefusalReasonResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RqthRefusalReasonResourceFromJSON(json: any): RqthRefusalReasonResource {
    return RqthRefusalReasonResourceFromJSONTyped(json, false);
}

export function RqthRefusalReasonResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RqthRefusalReasonResource {
    return json as RqthRefusalReasonResource;
}

export function RqthRefusalReasonResourceToJSON(value?: RqthRefusalReasonResource | null): any {
    return value as any;
}

